type CandidateFilterOption = { id: string; label: string } | null;

export type CandidateFilters = {
  license_status: CandidateFilterOption;
  lead_source: CandidateFilterOption;
};

export const emptyLocalFilters: CandidateFilters = {
  license_status: null,
  lead_source: null,
} as const;

export const candidateFilterOptions = [
  {
    id: 'license_status',
    label: 'License',
    options: [
      { id: 'licensed', label: 'Licensed' },
      { id: 'unlicensed', label: 'Unlicensed' },
      { id: 'license_in_progress', label: 'License In Progress' },
      { id: 'unknown', label: 'Unknown' },
    ],
  },
  {
    id: 'lead_source',
    label: 'Lead Source',
    options: [
      { id: 'indeed', label: 'Indeed' },
      { id: 'monster', label: 'Monster' },
      { id: 'zip_recruiter', label: 'ZipRecruiter' },
      { id: 'meta', label: 'Meta' },
      { id: 'agent_referral_manual', label: 'Agent Referral (Manual)' },
      { id: 'agent_referral_self', label: 'Agent Referral (Self-Apply)' },
    ],
  },
] as const;
